import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  Grid,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  TableHead,
  TableContainer,
} from "@mui/material";
import classes from "../packagedSolution/createPackage.module.css";
import Input from "../../../component/inputpm";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import {formatDate} from "../../../helper/dateFormatter";

const ComponentComments = (props) => {
  useEffect(() => { });
  const t = props.t;
  const [comment, setComment] = useState("");
  const onChange = (event) => {
    setComment(event.target.value);
    props.onChange(event);
  };

  return (
    // <div>
    // </div >
    <React.Fragment>
      <Grid container spacing={1}>
        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          {/* <Typography className={classes.title} id="tableTitle"> */}
          <b>{t("PRODUCT_HISTORY")}</b>
          {/* </Typography> */}
        </Grid>
        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          <Card variant="outlined" style={{ borderRadius: "8px" }}>
            <TableContainer>
              <Table className="newGlobalTable">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("DATE")}</TableCell>
                    <TableCell>{t("STATE")}</TableCell>
                    <TableCell>{t("ADDITIONAL_INFO")}</TableCell>
                    <TableCell>{t("COMMENT")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.comments && props.comments.length > 0 ? (
                    <>
                      {props.comments
                        .sort((a, b) => (a && b ? b.sequence - a.sequence : 0))
                        .map((comment, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              {" "}
                              {comment.date
                                ? formatDate(comment.date)
                                : ""}{" "}
                            </TableCell>

                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                              {comment.status == "P_IN_DRAFT" &&
                                (comment.status == "P_IN_DRAFT" &&
                                  props.status == "P_IN_DRAFT" &&
                                  comment.iteration == props.comments.length ? (
                                  <u
                                    onClick={(event) =>
                                      props.productStateChange(false, "REVIEW")
                                    }
                                    style={{ cursor: "pointer" }}
                                    // className='activeLink'
                                    className="button"
                                  >
                                    {comment.statusDisplayName}
                                  </u>
                                ) : (
                                  <>{comment.statusDisplayName}</>
                                ))}
                              {comment.status != "P_IN_DRAFT" &&
                                comment.status != "P_PUBLISHED" &&
                                comment.status != "P_EXPIRED" &&
                                comment.status != "P_RETIRED" &&
                                comment.status != "P_REJECTED" &&
                                comment.status != "P_OBSOLETE" &&
                                (comment.iteration == props.comments.length ? (
                                  <u
                                    onClick={(event) => props.confirmApprove()}
                                    style={{ cursor: "pointer" }}
                                    // className='activeLink'
                                    className="button"
                                  >
                                    {comment.statusDisplayName}
                                  </u>
                                ) : (
                                  <>{comment.statusDisplayName}</>
                                ))}
                              {comment.status == "P_PUBLISHED" &&
                                (comment.iteration == props.comments.length ? (
                                  <u
                                    onClick={(event) =>
                                      props.productStateChange(
                                        false,
                                        "P_RETIRED",
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                    // className='activeLink'
                                    className="button"
                                  >
                                    {comment.statusDisplayName}
                                  </u>
                                ) : (
                                  <>{comment.statusDisplayName}</>
                                ))}
                              {comment.status == "P_RETIRED" &&
                                (comment.status == "P_RETIRED" &&
                                  props.status == "P_RETIRED" &&
                                  comment.iteration == props.comments.length ? (
                                  <u
                                    onClick={(event) =>
                                      props.productStateChange(
                                        false,
                                        "P_OBSOLETE",
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                    // className='activeLink'
                                    className="button"
                                  >
                                    {comment.statusDisplayName}
                                  </u>
                                ) : (
                                  <>{comment.statusDisplayName}</>
                                ))}
                              {comment.status == "P_OBSOLETE" &&
                                comment.status == "P_OBSOLETE" &&
                                props.status == "P_OBSOLETE" &&
                                comment.iteration == props.comments.length && (
                                  <>{comment.statusDisplayName}</>
                                )}
                              {comment.status == "P_REJECTED" &&
                                comment.status == "P_REJECTED" &&
                                props.status == "P_REJECTED" &&
                                comment.iteration == props.comments.length && (
                                  <>{comment.statusDisplayName}</>
                                )}
                              {comment.status == "P_EXPIRED" &&
                                comment.status == "P_EXPIRED" &&
                                props.status == "P_EXPIRED" &&
                                comment.iteration == props.comments.length && (
                                  <>{comment.statusDisplayName}</>
                                )}
                            </TableCell>
                            <TableCell>
                              {comment.action && (
                                <>
                                  {comment.action} {comment.performedBy}
                                </>
                              )}
                            </TableCell>
                            <TableCell>{comment.comment}</TableCell>
                          </TableRow>
                        ))}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No comments
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
          {/* <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('DATE')}</TableCell>
                                    <TableCell>{t('ACTION')} / {t('STATUS')}</TableCell>
                                    <TableCell>{t('PERSON')}</TableCell>
                                    <TableCell>{t('STATE')}</TableCell>
                                    <TableCell>{t('COMMENT')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(props.comments && props.comments.length > 0 ) ?
                                <>
                                {props.comments
                                    .sort((a, b) => (a && b ? b.sequence - a.sequence : 0))
                                    .map((comment, index) =>
                                    <TableRow key={index}>
                                        <TableCell> {comment.date ? convertDate(comment.date) : ''} </TableCell>
                                        <TableCell>
                                            {comment.status == "P_IN_DRAFT" &&
                                                (
                                                comment.status == "P_IN_DRAFT" && props.status == "P_IN_DRAFT"
                                                    ?
                                                    <u onClick={event => props.productStateChange(false, 'REVIEW')}
                                                        style={{cursor: 'pointer' }}
                                                    >
                                                        {comment.action}
                                                    </u>
                                                    :
                                                    <>{comment.action}</>
                                                )
                                            }
                                            {comment.status != "P_IN_DRAFT" && comment.status != "P_PUBLISHED" && 
                                            comment.status != "P_RETIRED" && comment.status != "P_OBSOLETE" && 
                                                    
                                                (comment.iteration == props.comments.length
                                                    ?
                                                    <u onClick={event => props.confirmApprove()}
                                                        style={{cursor: 'pointer' }}
                                                    >
                                                        {comment.action}
                                                    </u>
                                                    :
                                                    <>{comment.action}</>
                                                )
                                                
                                            }
                                            {comment.status == "P_PUBLISHED" && 
                                                    
                                                (comment.iteration == props.comments.length
                                                    ?
                                                    <u onClick={event => props.productStateChange(false, 'P_RETIRED')}
                                                        style={{cursor: 'pointer' }}
                                                    >
                                                        {comment.action}
                                                    </u>
                                                    :
                                                    <>{comment.action}</>
                                                )
                                                
                                            }
                                            {comment.status == "P_RETIRED" && 
                                                    
                                                    (comment.iteration == props.comments.length
                                                        ?
                                                        <u onClick={event => props.productStateChange(false, 'P_OBSOLETE')}
                                                            style={{cursor: 'pointer' }}
                                                        >
                                                            {comment.action}
                                                        </u>
                                                        :
                                                        <>{comment.action}</>
                                                    )
                                                    
                                                }
                                        </TableCell>
                                        <TableCell>{comment.performedBy}</TableCell>
                                        <TableCell>{comment.statusDisplayName}</TableCell>
                                            
                                            
                                        <TableCell>
                                            {comment.comment}
                                        </TableCell>
                                    </TableRow>
                                )}
                                </>
                                :
                                    <TableCell colSpan={5} align='center'>
                                        No comments
                                    </TableCell>
                            }
                            </TableBody>
                        </Table> */}
        </Grid>
      </Grid>
      {/* {props.status !== "P_IN_DRAFT" && 
                <Grid container style={{marginTop: '24px'}}>
                    <Grid item xs={12}> 
                        <Typography className={classes.title} id="tableTitle">
                            {t('PRODUCT_APPROVE_ACTION')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} align='left'>
                        <Link to={`/updatePackage?packageId=${props.offeringProductId}&packageMode=edit&addToCatalog=false`} 
                            style={props.showApprovalLink ? {color: '#f58320'} : {pointerEvents: 'none', color: 'gray'}}>
                                    {props.nextTask}
                        </Link>
                    </Grid>
                </Grid>
                } */}
      {props.showCommentInput && (
        <Grid container spacing={1} style={{ marginTop: "1rem" }}>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <b>{t("ADD_COMMENT")}</b>
          </Grid>
          <Grid
            item
            align="center"
            size={{
              xs: 12,
            }}
          >
            <Input
              name={"comment"}
              value={comment}
              onChange={(event) => onChange(event)}
              placeholder={props.readonly ? "" : t("ADD_COMMENT")}
              variant={"outlined"}
              inputProps={{ multiline: true, rows: 2, cols: 31 }}
              size={"small"}
              disabled={props.readonly}
            />
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    roles: state.auth.roles,
    userPerms: state.auth.userPerms,
    providerId: state.auth.tenantId,
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
    providerName: state.auth.providerName,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    loggedInUserId: state.auth.loggedInUserId,
  };
};
export default connect(mapStateToProps)(
  withTranslation("translations")(ComponentComments),
);
